// Constants for management server camera limits
const MANAGEMENT_SERVER_CAMERA_LIMITS = {
  CONFIG_1: 300,
  CONFIG_2: 1200,
  CONFIG_3: 2500,
  CONFIG_4: 5000
} as const

// Management server camera limit checking
export const checkNumberOfCamerasExceedingManagementServerSelection = (hasManagementServer: boolean, supportedCamerasSelection: number, camerasAmount: number): boolean => {
  if (!hasManagementServer || supportedCamerasSelection === 0) {
    return false
  }

  const cameraLimits = [
    0, // No limit for selection 0
    MANAGEMENT_SERVER_CAMERA_LIMITS.CONFIG_1,
    MANAGEMENT_SERVER_CAMERA_LIMITS.CONFIG_2,
    MANAGEMENT_SERVER_CAMERA_LIMITS.CONFIG_3,
    MANAGEMENT_SERVER_CAMERA_LIMITS.CONFIG_4
  ]

  const limit = cameraLimits[supportedCamerasSelection]
  return limit !== undefined && camerasAmount > limit
}

export { MANAGEMENT_SERVER_CAMERA_LIMITS }
